module.exports = __webpack_public_path__ + "static/media/enrollment.83526bad.png";